module.exports = __webpack_public_path__ + "static/media/1017128.62994709.png";